export enum SecurityTransactionType {
    None = 0,
    TitleOnly = 1,
    RegistrationOnly = 2,
    TitleandRegistration = 3,
    IssueTemporaryPlacard = 5,
    ReplaceTemporaryPlacard = 6,
    RenewPermanentPlacard = 7,
    CancelTemporaryPlacard = 8,
    IssuePermanentPlacard = 9,
    ReplacePermanentPlacard = 10,
    CancelPermanentPlacard = 11,
    IssuePermit = 12,
    ReprintPermit = 13,
    CancelPermit = 14,
    PrintTitle = 15,
    CorrectTitle = 16,
    CancelTitle = 17,
    RenewRegistration = 18,
    DuplicateRegistration = 19,
    UpdateRegistration = 20,
    SuspendRegistration = 21,
    AddInsurance = 22,
    UpdateInsurance = 23,
    AbandonedVehicle = 24,
    SoldNotice = 25,
    RemoveSoldNotice = 26,
    AddBrand = 27,
    MaintainBrand = 28,
    AddDuplicateCustomer = 29,
    ReduceFLP = 30,
    IssueCashDrawer = 31,
    RollupBusinessUnit = 32,
    BalanceCashDrawerCSR = 33,
    BalanceCashDrawerAcct = 34,
    Checkout = 35,
    ViewReceipt = 36,
    ReceiptDetails = 37,
    ReceiptManagement = 38,
    BalanceVault = 39,
    DepositSlip = 40,
    EndofDayClosing = 41,
    LECUAuditReport = 42,
    IAAuditReport = 43,
    PrintBalanceCDReceipt = 44,
    UpdateDepositSlip = 45,
    CashPickup = 46,
    CashPickupReceipt = 47,
    CashPickupConfirmation = 48,
    ThirdPartyEndofDayClosing = 49,
    AddCustomer = 50,
    SearchCustomer = 51,
    CreateNotification = 52,
    NotificationAdmin = 53,
    Customer360 = 54,
    GeneralLedger = 55,
    LookupManagement = 56,
    ServiceEscalationManagement = 57,
    DeveloperMenu = 58,
    CredentialIssuance = 59,
    JournalEntryTemplateInquiry = 60,
    DistributionManagement = 61,
    DistributionProductMaps = 62,
    GLAccountManagement = 63,
    GLInquiry = 64,
    GLTrialBalance = 65,
    GLAssetsandLiabilities = 66,
    JournalEntryManagement = 68,
    ReinstateRegistration = 69,
    CancelRegistration = 70,
    PrePaidVoucherVerification = 73,
    OfficeDeposit = 74,
    BankStatementManagement = 75,
    Reconciliation = 76,
    ThirdPartyCloseCashDrawer = 77,
    ThirdPartyDeposit = 78,
    TitleViewer = 79,
    FundCustomerAccount = 80,
    PurchasePrePaidVoucher = 81,
    DisbursementRequest = 82,
    DisbursementManagement = 83,
    eIDRegistration = 84,
    PPVManagement = 85,
    ManageCase = 86,
    SearchAFIS = 88,
    SearchBankAccounts = 89,
    SearchBankStatements = 90,
    SearchDistribution = 91,
    SearchDistributionPrdMaps = 95,
    SearchGeneralLedger = 96,
    SearchJournalEntry = 97,
    SearchOfficeDeposits = 98,
    SearchPrepaidVoucher = 99,
    FleetManagement = 100,
    MetadataManagement = 101,
    UserManagement = 103,
    ReceiptsAccountingReports = 104,
    EmissionsService = 105,
    ConfigurationManagement = 106,
    HurfBreakdownManagement = 107,
    RequestRegistrationCredit = 108,
    RemoteTestInstructionPermit = 109,
    CountyCityPopulation = 110,
    eTitleTransfer = 111,
    ComplianceManagement = 114,
    VehicleMVR = 115,
    DriverMVR = 116,
    eTitleTransferLog = 117,
    CredentialRenewal = 118,
    CredentialDuplicate = 119,
    VehicleInquiry = 120,
    VehicleUpdate = 121,
    LiensAppliedandReleased = 122,
    HURFPeriodManagement = 123,
    InsuranceBatch = 124,
    InsuranceBatchErrors = 125,
    FeeEstimation = 1108,
    ExceptionLog = 1109,
    VLTDistributionManagement = 1110,
    ElectronicPmtVerificationInq = 1112,
    CreditEstimate = 1113,
    CustomerDigitalRefundRequestReversal = 1114,
    TabReplacement = 2112,
    CustAccntPaySAZ = 2116,
    MiscellaneousPurchase = 2117,
    VisionOnlyTest = 2118,
    SkillOnlyTest = 2119,
    KnowledgeOnlyTest = 2120,
    DriverReinstatement = 2121,
    CredentialAdjustments = 2122,
    NonStandardTemporaryCredentials = 2123,
    DriverRecord = 2124,
    NRVCProcessing = 2125,
    MedicalExamCertificate = 2126,
    TSAHazmat = 2127,
    ManageRestrictions = 2128,
    VisionExamReports = 2129,
    MedicalReviewProgram = 2130,
    CancelCredential = 2131,
    UnlicensedDealerReport = 2132,
    FuelTaxReportManagement = 2134,
    ExtDigitalLicensePlateProxy = 2135,
    StandAloneCommercialSkillTest = 2136,
    StandAloneNonCommercialSkillTest = 2137,
    StandAloneKnowledgeTest = 2138,
    StandAloneVisionScreening = 2139,
    StandAloneMotorcycleSkillTest = 2140,
    StandAloneAddRemoveRestrictions = 2141,
    DriverInquiry = 2142,
    DriverUpdate = 2143,
    RevenueAccountReports = 2144,
    HURFCalculationManagement = 2145,
    VehicleRegistrationReports = 2146,
    CancelTRP = 2147,
    CorrespondenceTemplateManagement = 2148,
    BatchJobManagement = 2153,
    AccommodativeDataSearch = 2187,
    TransferCustomerAccount = 2199,
    ReplaceGFDecal = 2203,
    MiscellaneousReversal = 2204,
    DepositReversalAdjustment = 2210,
    ImageStatusTool = 2213,
    WIPTool = 2215,
    RequiredComplianceReport = 2231,
    CommercialPermittingGeneral = 2270,
    Collection = 2227,
    ChargebackLookup = 2326,
    TeleMVD = 2410,
    ReceiptSearch = 2411,
    PhotoFirstWorkstation = 2444,
    ATPManagement = 2470,
    BUTabletSkillsTest = 2477,
    OnDemandAuthentication = 2478,
    CustomerSurveyManagement = 2479,
    CustomerSurveySendSMS = 2484,
    ATPCompany = 2489,
    ATPDashboard = 2490,
    GetCSTIMSCommercialExamResults = 2495,
    PerformCSTIMSCommercialExams = 2496,
    CanPrintDriverEvents = 2529
}
